import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from './ProtectedRoute';
import { routes } from './routes';

export const Router: React.FC = () => (
  <BrowserRouter>
    <Routes>
      {routes.map(({ component: Component, layout: Layout, path, authRoles }, index) => (
        <Route
          path={path}
          key={index}
          element={
            <ProtectedRoute authRoles={authRoles}>
              {Layout ? (
                <Layout>
                  <Component />
                </Layout>
              ) : (
                <Component />
              )}
            </ProtectedRoute>
          }
        />
      ))}
      <Route path='*' element={<Navigate to={'/404'} />} />
    </Routes>
  </BrowserRouter>
);
